import { QuantitySelector } from '@/components/ui/QuantitySelector';
import { useLanguage } from '@/lib/i18n';
import { cn } from '@/lib/utils';
import { useCartFetchStore } from '@/stores/cartFetchStore';
import { ProductListItem } from '@/types';
import { Trash2 } from 'lucide-react';

interface ActionBlock {
    variation: ProductListItem;
}

export function ActionBlock({ variation }: ActionBlock) {
    const { t } = useLanguage();

    const { removeItem, addItem, items } = useCartFetchStore();
    const cartItem = items.find(
        (item) => Number(item.productVariation.id) === Number(variation.id),
    );

    const cartItemId = cartItem ? cartItem.id : undefined;

    const isAvailable = variation.inStock;

    return cartItem && cartItemId !== undefined ? (
        <div className="flex justify-between gap-2">
            <button
                onClick={() => removeItem(cartItemId)}
                className="h-8 flex-1 self-start px-3 py-2 text-xs text-zinc-600 transition-colors hover:text-red-500 md:h-6 md:py-1"
            >
                <Trash2 className="h-5 w-5" />
            </button>
            <QuantitySelector
                className="flex-2 justify-between"
                variation={variation}
                itemId={cartItemId}
                value={cartItem?.quantity}
            />
        </div>
    ) : (
        <button
            className={cn(
                'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:ring-1 focus-visible:ring-brand-gold focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50',
                'bg-brand-gold text-black shadow-sm hover:bg-brand-gold/90',
                'h-10 text-base md:h-8 md:text-xs',
            )}
            onClick={() => addItem(variation)}
            disabled={!isAvailable}
        >
            {t('common.buy')}
        </button>
    );
}
